module.exports = __webpack_public_path__ + "img/bin.fccf21ff.svg";